if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        if (this.elements.viewer) {
          this.elements.viewer.enableSliderLooping = true;
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          
          const prevButton = this.elements.viewer.querySelector('button[name="previous"]');
          const nextButton = this.elements.viewer.querySelector('button[name="next"]');
          
          if (prevButton) {
            prevButton.removeAttribute('disabled');
            prevButton.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.onNavButtonClick('prev');
            });
          }
          if (nextButton) {
            nextButton.removeAttribute('disabled');
            nextButton.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.onNavButtonClick('next');
            });
          }
        }

        if (this.elements.thumbnails) {
          this.elements.thumbnails.enableSliderLooping = true;
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });

          const thumbPrevBtn = this.elements.thumbnails.querySelector('button[name="previous"]');
          const thumbNextBtn = this.elements.thumbnails.querySelector('button[name="next"]');
          if (thumbPrevBtn) {
            thumbPrevBtn.removeAttribute('disabled');
            thumbPrevBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.onNavButtonClick('prev');
            });
          }
          if (thumbNextBtn) {
            thumbNextBtn.removeAttribute('disabled');
            thumbNextBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.onNavButtonClick('next');
            });
          }
        }

        if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }

        this.enableInfiniteButtons();
      }

      enableInfiniteButtons() {
        if (this.elements.viewer) {
          const prev = this.elements.viewer.querySelector('button[name="previous"]');
          const next = this.elements.viewer.querySelector('button[name="next"]');
          if (prev) prev.removeAttribute('disabled');
          if (next) next.removeAttribute('disabled');
        }
        if (this.elements.thumbnails) {
          const prev = this.elements.thumbnails.querySelector('button[name="previous"]');
          const next = this.elements.thumbnails.querySelector('button[name="next"]');
          if (prev) prev.removeAttribute('disabled');
          if (next) next.removeAttribute('disabled');
        }
      }

      onNavButtonClick(direction) {
        if (!this.elements.viewer) return;
        const mediaItems = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
        if (mediaItems.length <= 1) return;
        
        let currentIndex = mediaItems.findIndex(item => item.classList.contains('is-active'));
        if (currentIndex === -1) currentIndex = 0;
        
        let newIndex;
        if (direction === 'next') {
          newIndex = (currentIndex + 1) % mediaItems.length;
        } else {
          newIndex = (currentIndex - 1 + mediaItems.length) % mediaItems.length;
        }
        
        const targetMedia = mediaItems[newIndex];
        if (targetMedia && targetMedia.dataset.mediaId) {
          this.setActiveMedia(targetMedia.dataset.mediaId, false);
        }
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.enableInfiniteButtons();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) {
              activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          if (activeThumbnail && activeThumbnail.dataset.mediaPosition) {
            this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
          }
        }
        
        this.enableInfiniteButtons();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        const btn = thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', true);

        if (typeof this.elements.thumbnails.isSlideVisible === 'function' && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          return;
        }

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          if (window.accessibilityStrings && window.accessibilityStrings.imageAvailable) {
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          }
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer || !this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        if (this.elements.viewer.sliderItems) {
          this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    }
  );
}
